import apiFetch from '../core/apiFetch';
import { checkStatus, handleError } from '../../utils/api';
import {
  AuthCodeSession,
  AuthCodeSessionResponse,
} from '../../interfaces/login';
import {
  AUTH_CODE_SESSION_ERROR,
  TOO_MANY_REQUESTS,
} from '../../constants/errors';
import { getAuthTokenAsync } from '../../utils/authToken';

const createAuthCodeSessionAsync = async ({
  authCodeId,
  userId,
  code,
  lockedUser = false,
}: AuthCodeSession): Promise<{
  error?: { code: string; payload?: any };
  authCodeSession?: AuthCodeSessionResponse;
}> => {
  const url = `api/v1/auth_code/sessions`;

  try {
    const authToken = await getAuthTokenAsync();

    const response = await apiFetch(authToken, url, {
      method: 'POST',
      body: JSON.stringify({
        session: {
          auth_code_id: authCodeId,
          user_id: userId,
          code,
          locked_user: lockedUser,
        }, // eslint-disable-line @typescript-eslint/camelcase
      }),
    });

    await checkStatus(response);

    const { session } = await response.json();
    const { user, sso, jwt, redirect_url: redirectUrl } = session;

    return {
      authCodeSession: {
        user,
        sso: { idpId: sso.idp_id, statusToken: sso.status_token },
        jwt,
        redirectUrl,
      },
    };
  } catch (error) {
    const { response } = error;

    if (response.status === 422) {
      return {
        error: {
          code: AUTH_CODE_SESSION_ERROR,
          payload: { code: 'Invalid Code. Try again or resend code' },
        },
      };
    }

    if (response.status === 429) {
      return {
        error: {
          code: TOO_MANY_REQUESTS,
          payload: {
            code:
              "We're sorry, but you have sent too many requests. Please try again later.",
          },
        },
      };
    }

    handleError('unexpected status - create auth code session', error);
    return { error: { code: AUTH_CODE_SESSION_ERROR } };
  }
};

export default createAuthCodeSessionAsync;
